import Link from 'next/link';

import { Colors, Text } from '@rockalingua/ui';

import { Background, Container } from './Footer.styled';

export default function Footer() {
  return (
    <Background>
      <Container>
        <Text variant="grey-16-medium" color={Colors.WHITE}>
          © {new Date().getFullYear()} Rockalingua
        </Text>
        <Text variant="grey-22-bold" color={Colors.WHITE}>
          •
        </Text>
        <Link
          href="https://rockalingua.com/legal/termsOfUse"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Text variant="grey-16-medium" color={Colors.WHITE}>
            Legal
          </Text>
        </Link>
      </Container>
    </Background>
  );
}
